import {match} from 'ts-pattern';

export function roundByCurrency(value: number, currency: string) {
  return match(currency)
    .with('CZK', () => Math.round(value / 1000) * 1000)
    .otherwise(() => Math.round(value / 100) * 100);
}
